<div class="subtitle-container">
  <span
    [ngStyle]="{
      'font-size': fontSize + 'vw',
      'font-family': fontFamily,
      'padding-bottom': textBotPadding + 'vw'
    }"
    >{{ subtitleText }}</span
  >
  <img
    src="assets/main-game/main-screen/DeviderLine.png"
    alt="devider"
    class="devider"
  />
</div>
